var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachContactEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "304px",
    height: "245px",
    viewBox: "0 0 304 245",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "attach-contact-empty-state") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 59,
    width: 150,
    height: 165,
    rx: 5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.0%",
    y: "-6.4%",
    width: "126.0%",
    height: "123.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 9,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.2   0 0 0 0 0.282352941   0 0 0 0 0.447058824  0 0 0 0.141799607 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DDE1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E98A0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DDE1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E98A0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DDE1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E98A0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-26.4103805%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84DB49",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DB423",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 170,
    y: 0,
    width: 100,
    height: 130,
    rx: 5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-47.0%",
    y: "-19.2%",
    width: "194.0%",
    height: "172.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 22,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.200145005   0 0 0 0 0.280398118   0 0 0 0 0.4471524  0 0 0 0.122951267 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DDE1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E98A0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DDE1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E98A0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DDE1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E98A0",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Populate---attach-contact-empty-satate",
    transform: "translate(-1055.000000, -344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attach-contact-empty-state",
    transform: "translate(1065.000000, 346.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,95 L150,95",
    id: "Line-2",
    stroke: "#E1E0E4",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-3)",
    x: 14,
    y: 74,
    width: 61,
    height: 9,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "url(#linearGradient-3)",
    x: 14,
    y: 114,
    width: 61,
    height: 9,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "url(#linearGradient-4)",
    x: 14,
    y: 139,
    width: 35,
    height: 9,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "url(#linearGradient-3)",
    x: 14,
    y: 164,
    width: 61,
    height: 9,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "url(#linearGradient-5)",
    x: 14,
    y: 189,
    width: 91,
    height: 9,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line-3",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero",
    transform: "translate(156.500000, 77.000000) scale(-1, 1) translate(-156.500000, -77.000000) ",
    points: "137 79 176 79 176 75 137 75"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(124.000000, 69.000000)",
    fill: "#FFFFFF",
    stroke: "#4DB423",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2,
    y: 2,
    width: 12,
    height: 12,
    rx: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon-person",
    transform: "translate(211.000000, 14.000000)",
    fill: "#8F98A1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,19 C18,19.5522847 17.5522847,20 17,20 C16.4477153,20 16,19.5522847 16,19 L16,17 C16,15.3431458 14.6568542,14 13,14 L5,14 C3.34314575,14 2,15.3431458 2,17 L2,19 C2,19.5522847 1.55228475,20 1,20 C0.44771525,20 0,19.5522847 0,19 L0,17 C3.33066907e-16,14.2385763 2.23857625,12 5,12 L13,12 C15.7614237,12 18,14.2385763 18,17 L18,19 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,10 C6.23857625,10 4,7.76142375 4,5 C4,2.23857625 6.23857625,0 9,0 C11.7614237,0 14,2.23857625 14,5 C14,7.76142375 11.7614237,10 9,10 Z M9,8 C10.6568542,8 12,6.65685425 12,5 C12,3.34314575 10.6568542,2 9,2 C7.34314575,2 6,3.34314575 6,5 C6,6.65685425 7.34314575,8 9,8 Z",
    id: "Oval"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    fill: "url(#linearGradient-9)",
    x: 186,
    y: 51,
    width: 51,
    height: 9,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-15",
    fill: "url(#linearGradient-10)",
    x: 186,
    y: 101,
    width: 26,
    height: 9,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    fill: "url(#linearGradient-11)",
    x: 186,
    y: 76,
    width: 68,
    height: 9,
    rx: 4.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachContactEmptyState);
export default __webpack_public_path__ + "static/media/attach-contact-empty-state.e2e62e8e050a8942182f0ed3bbdeb841.svg";
export { ForwardRef as ReactComponent };